import axios from 'axios'

function getRequest(url, data) {
    return new Promise(function (resolve, reject) {
        axios.get(url, data).then(function (res) {
            resolve(res)
        }, function (err) {
            reject(err)
        })
    })
}

function postRequest(url, data) {
    return new Promise(function (resolve, reject) {
        axios.post(url, data).then(function (res) {
            resolve(res)
        }, function (err) {
            reject(err)
        })
    })
}



// axios.defaults.baseURL = ''
// 开发
axios.defaults.baseURL = '/app'
export default {

    // 首页
    homeApi(data) {
        return getRequest('/yjzx/home/homeList', data)
    },
    // banner
    banner(data) {
        return getRequest('/yjzx/banner/lists', data)
    },
    // 次页面导航
    sideBanner(data) {
        return getRequest('/yjzx/html/BannerList', {
            params: data
        })
    },
    // 一级导航
    navOne(data) {
        return getRequest('/yjzx/home/firstNavigationList', data)
    },
    // 二级导航
    navTwo(data) {
        return getRequest('/yjzx/home/secondaryNavigationList', {
            params: data
        })
    },
    // 二级页面  学校概况
    erjiPage(data) {
        return getRequest('/yjzx/html/schoolList', {
            params: data
        })
    },
    // 二级页面   新闻动态
    newsTai(data) {
        return getRequest('/yjzx/html/newsList', {
            params: data
        })
    },
    // 新闻详情
    newsDetail(data) {
        return getRequest('/yjzx/html/getNewsInfo', {
            params: data
        })
    },
    // 党建工作
    djWork(data) {
        return getRequest('/yjzx/html/partyList', {
            params: data
        })
    },
    // 管理团队
    gltd(data) {
        return getRequest('/yjzx/html/schoolGwList', {
            params: data
        })
    },

    // 服务保障
    fwbzApi(data) {
        return getRequest('/yjzx/html/xybz', {
            params: data
        })
    },

    // 顾问详情
    gwxqDetail(data) {
        return getRequest('/yjzx/teacher/' + data, {})
    },
    // 教师风采  
    jsfcApi(data) {
        return getRequest('/yjzx/html/teacherFcList', {
            params: data
        })
    },
    // 教师代表详情
    daibiao(data) {
        return getRequest('/yjzx/html/' + data, {})
    },
    // 课程介绍
    kcjsApi(data) {
        return getRequest('/yjzx/html/courseList', {
            params: data
        })
    },

    // 学生活动
    xshdApi(data) {
        return getRequest('/yjzx/html/stuActivityList', {
            params: data
        })
    },
    // 国际交流
    gjjlApi(data) {
        return getRequest('/yjzx/html/internationalList', {
            params: data
        })
    },
    // 联系方式
    lxfsApi(data) {
        // /yjzx/html/recruitStudentList
        return getRequest('/yjzx/html/recruitStudentList', {
            params: data
        })
    },
    // 加入我们
    jrwmApi(data) {
        return getRequest('/yjzx/html/joinUsList', {
            params: data
        })
    },

    //   选课课程列表
    keApi(data) {
        return getRequest('/yjzx/course/couList', {
            params: data
        })
    },
    // 提交选课
    tiKe(data) {
        return getRequest('/yjzx/course/addCou', {
            params: data
        })
    },
    // 选课详情
    keDetail(data) {
        return getRequest('/yjzx/course/xCouInfo', {
            params: data
        })
    },




}